<div class="page-container p-grid">
  <div class="p-col-12">
    <h1>Leverantörsfakturor</h1>
    <p-button
      *ngIf="(relationshipsLoading | async) === false"
      (click)="viewAllInvoicesPDF()"
      icon="pi pi-file-pdf"
      label="Ladda ner fakturor"
    ></p-button>
  </div>
  <div class="p-col-12" *ngIf="relationshipsLoading | async">
    <spinner></spinner>
  </div>
  <div
    class="p-col-12 p-g-nopad"
    *ngIf="(relationshipsLoading | async) === false"
  >
    <app-emptyState
      *ngIf="dataSet.length === 0"
      [model]="'Invoice'"
    ></app-emptyState>
    <div *ngFor="let supplierInvociesBySource of dataSet; trackBy: rowTrackBy">
      <div class="p-grid">
        <div class="p-col-12">
          <hyperion-card>
            <h3>{{ supplierInvociesBySource.name }}</h3>
            <supplier-invoice-row-holder
              [projectId]="projectId"
              [dataSet]="supplierInvociesBySource.invoices"
              [functionsData]="functionsData"
              [projectDropdown]="allProjectsLabels"
              [companyCostTypeId]="supplierInvociesBySource.companyCostTypeId"
              (refetchSupplierInvoices)="getSupplierInvoices()"
            ></supplier-invoice-row-holder>
          </hyperion-card>
        </div>
      </div>
    </div>
  </div>
</div>
